var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

export default function isObject(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !Array.isArray(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-named-media-query/node_modules/fela-utils/es/isObject.js
// module id = 981
// module chunks = 1